import cn from 'classnames';
import { FC, HTMLProps, MouseEvent, useCallback, useEffect } from 'react';
import { Button } from '../../../components/button/button';
import { Divider } from '../../../components/divider/divider';
import { useLang } from '../../../hooks/use-lang';
import { useQueryParams } from '../../../hooks/use-query-params';
import { Tooltip } from '../../tooltip/tooltip';
import s from './dropdown-filter-popup.module.css';

interface Props extends Omit<HTMLProps<HTMLDivElement>, 'onSubmit'> {
  onSubmit: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | KeyboardEvent) => void;
  onReset: () => void;
  name: string;
  isOpen: boolean;
  onOpen: (state: boolean) => void;
}

export const DropdownFilterPopup: FC<Props> = (props) => {
  const { className, children, onReset, onSubmit, name, isOpen, onOpen } = props;
  const { t } = useLang();

  const params = useQueryParams().getQueryParams();

  const isActive = params[name] || params[`${name}-check`];

  const handleReset = useCallback(() => {
    onReset();
  }, [onReset]);

  const handleSubmit = useCallback(
    (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | KeyboardEvent) => {
      onSubmit(e);
    },
    [onSubmit],
  );

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleSubmit(e);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className={s.feature}>
      <Tooltip
        trigger={null}
        triggerWrapperClassName={cn(s.trigger, !isActive && s.inActive)}
        optionsWrapperClassName={cn(s.options, className)}
        open={isOpen}
        onOpen={onOpen}
        offset={34}
      >
        <>
          {children}
          <Divider />
          <div className={s.actions}>
            <Button variant="secondary" onClick={handleReset}>
              {t('Сбросить')}
            </Button>
            <Button onClick={handleSubmit}>{t('Готово')}</Button>
          </div>
        </>
      </Tooltip>
    </div>
  );
};
